import { render, staticRenderFns } from "./CartMenuIcon.vue?vue&type=template&id=0fd1c4ef&scoped=true"
import script from "./CartMenuIcon.vue?vue&type=script&lang=js"
export * from "./CartMenuIcon.vue?vue&type=script&lang=js"
import style0 from "./CartMenuIcon.vue?vue&type=style&index=0&id=0fd1c4ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1c4ef",
  null
  
)

export default component.exports